import { render } from "./BottomToolBar.vue?vue&type=template&id=6b49160e&scoped=true&ts=true"
import script from "./BottomToolBar.vue?vue&type=script&lang=ts"
export * from "./BottomToolBar.vue?vue&type=script&lang=ts"

import "./BottomToolBar.vue?vue&type=style&index=0&id=6b49160e&scoped=true&lang=css"

import exportComponent from "/home3/sli/web/public/resources/editorvue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b49160e"]])

export default __exports__